// frontend/src/app/auth/onboarding.guard.ts
import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { getUserGroupsOrNull, resolveHome } from '../shared/utils/auth-groups.util';

/**
 * Réserve `/onboarding` à l'utilisateur connecté qui n'a **aucun** groupe : il
 * n'y a rien d'autre à lui montrer. Dès qu'un groupe est attribué, la page perd
 * sa raison d'être et la garde renvoie vers l'accueil du profil — Finances,
 * espace gestionnaire, ou `/no-access` pour le seul rôle de base.
 *
 * Elle lit les groupes dans l'id token (`getUserGroupsOrNull`) et non plus dans
 * `fetchUserAttributes()`, qui ne porte pas `cognito:groups` : cette page
 * restait donc accessible à des utilisateurs déjà habilités.
 */
@Injectable({ providedIn: 'root' })
export class OnboardingGuard implements CanActivate {
  private router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return from(getUserGroupsOrNull()).pipe(
      map(groups => {
        if (!groups) {
          return this.router.createUrlTree(['/login']);
        }
        return groups.length === 0 ? true : this.router.createUrlTree([resolveHome(groups)]);
      }),
      catchError(() => of(this.router.createUrlTree(['/login'])))
    );
  }
}
